import React, { useEffect, useState } from "react";
import { Card, Row, Col, Empty } from "antd";
import Table from "../../components/Table/Table";
import FinancialGraph from "../../components/FinancialGraph/FinancialGraph";
import { orderBy } from "lodash";
import Localize from "../../libs/localization";
import { currencyFormatter } from "../../libs/utils";
import GatedTableEmptyState from "../../design-library/GatedTableEmptyState/GatedTableEmptyState.component";

const MOCK_FINANCIAL_DATA = {
  2023: { revenue: 4200000, operatingResult: 380000, employees: 42 },
  2022: { revenue: 3800000, operatingResult: 310000, employees: 38 },
  2021: { revenue: 3350000, operatingResult: 260000, employees: 35 },
};

const renderData = (data, sort = "desc", format = false) => {
  if (!data) return [];
  const tableData = [];
  Object.keys(data).map((year, i) => {
    if (
      data[year].revenue ||
      data[year].operatingResult ||
      data[year].employees ||
      data[year].personnelCost
    ) {
      const tempData = {};
      tempData.year = year;
      tempData.key = i;
      tempData.revenue = data[year].revenue ? data[year].revenue : 0;
      tempData.operatingResult = data[year].operatingResult
        ? data[year].operatingResult
        : 0;
      tempData.employees = data[year].employees ? data[year].employees : 0;
      tempData.personnelCost = data[year].personnelCost;
      if (format) {
        tempData.revenue = currencyFormatter.format(tempData.revenue);
        tempData.operatingResult = currencyFormatter.format(
          tempData.operatingResult,
        );
        if (tempData.personnelCost)
          tempData.personnelCost = currencyFormatter.format(
            tempData.personnelCost,
          );
      }
      tableData.push(tempData);
    }
  });
  return orderBy(tableData, "year", sort);
};

const CompanyFinancial = (props) => {
  const {
    data,
    hideGraph = false,
    hideTitle = false,
    hasAccess = true,
  } = props;
  const [showPersonnelCost, setShowPersonnelCost] = useState(false);

  const columns = [
    {
      title: (
        <div style={{ fontWeight: "bold" }}>{Localize("COMMON.YEAR")}</div>
      ),
      dataIndex: "year",
    },
    {
      title: (
        <div style={{ fontWeight: "bold" }}>{Localize("COMMON.REVENUE")}</div>
      ),
      dataIndex: "revenue",
    },
    {
      title: (
        <div style={{ fontWeight: "bold" }}>{Localize("COMMON.INCOME")}</div>
      ),
      dataIndex: "operatingResult",
    },
    {
      title: (
        <div style={{ fontWeight: "bold" }}>{Localize("COMMON.EMPLOYEES")}</div>
      ),
      dataIndex: "employees",
    },
  ];

  useEffect(() => {
    if (!data) return;
    Object.keys(data).forEach((year) => {
      if (!!data[year].personnelCost) setShowPersonnelCost(true);
    });
  }, [data]);

  const tableColumns = showPersonnelCost
    ? [
        ...columns,
        {
          title: (
            <div style={{ fontWeight: "bold" }}>
              {Localize("COMMON.PERSONNEL_COST")}
            </div>
          ),
          dataIndex: "personnelCost",
        },
      ]
    : columns;

  return (
    <Card
      title={
        !hideTitle ? (
          <h2>
            <b>{Localize("PAGES.COMPANIES.DETAIL.SECTIONS.FINANCIALS")}</b>
          </h2>
        ) : null
      }
      bordered={false}
      className="companyPage__body-card companyPage__body-card--custom customCard"
    >
      {!hasAccess ? (
        <>
          <Table
            data={[]}
            columns={columns}
            size="small"
            bordered={false}
            emptyText={
              <GatedTableEmptyState
                message={Localize(
                  "PAGES.COMPANIES.DETAIL.SECTIONS.FINANCIALS_GATED_MESSAGE",
                )}
              />
            }
          />
          {!hideGraph && (
            <div
              aria-hidden
              style={{
                marginTop: 50,
                filter: "blur(6px)",
                pointerEvents: "none",
                userSelect: "none",
              }}
            >
              <FinancialGraph
                data={renderData(MOCK_FINANCIAL_DATA, "asc")}
                showPersonnelCost={false}
              />
            </div>
          )}
        </>
      ) : data ? (
        <>
          <Table
            data={renderData(data, undefined, true)}
            columns={tableColumns}
            size="small"
            bordered={false}
          />
          {!hideGraph && (
            <div style={{ marginTop: 50 }}>
              <FinancialGraph
                data={renderData(data, "asc")}
                showPersonnelCost={showPersonnelCost}
              />
            </div>
          )}
        </>
      ) : (
        <Empty
          description={Localize(
            "PAGES.COMPANIES.DETAIL.SECTIONS.FINANCIALS_EMPTY",
          )}
        />
      )}
    </Card>
  );
};

export default CompanyFinancial;
